jQuery(($) => {
  const manageNotificationBar = {
    data_id: null,

    init: function () {
      if ($('.o-notification-bar').length) {
        this.data_id = $('.o-notification-bar').attr('data-id');

        if (localStorage.getItem('popState_' + this.data_id) != 'shown') {
          this.showNotificationBar();
        }

        $('.o-notification-bar__close-button').click(() => {
          this.closeNotificationBar();
        });
      }
    },

    closeNotificationBar: function () {
      localStorage.setItem('popState_' + this.data_id, 'shown');
      $('.o-notification-bar').hide();

      // Remove the hero classes when notification bar is closed
      this.removeHeroClasses();
    },

    hideNotificationBar: function () {
      $('.o-notification-bar').slideUp();

      // Remove the hero classes when notification bar is closed
      this.removeHeroClasses();
    },

    showNotificationBar: function () {
      if (localStorage.getItem('popState_' + this.data_id) !== 'shown') {
        $('.o-notification-bar').show();

        // Add the hero classes when notification bar is shown
        this.addHeroClasses();
      }
    },

    addHeroClasses: function () {
      $('body').addClass('body--has-notification')
    },

    removeHeroClasses: function () {
      $('body').removeClass('body--has-notification')
    }
  };

  // Initialize the notification bar when the page loads
  manageNotificationBar.init();

  // Export the notification bar logic to be used elsewhere
  window.manageNotificationBar = manageNotificationBar;
});
